import React from 'react';
import { Menu, Button } from 'antd';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { FormattedMessage } from 'react-intl';
import IconSvg from '../../components/common/IconSvg';
import { colors } from '../../constants/theme';
import { buttonHover, themeColors } from '../../constants/themes';

const { SubMenu } = Menu;

export const StyledMenuItem = styled(Menu.Item)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0.1;
  border-left: solid 1px #ebebeb;
  padding: 0;
  cursor: default;

  :last-of-type {
    border-right: solid 1px #ebebeb;
  }
`;

export const SalefreaksStyledMenuItem = styled(Menu.Item)``;

export const SalefreaksStyledMenu = styled(Menu)`
  ${process.env.APP_NAME === 'SALEFREAKS' &&
    `.ant-menu-item-selected {
    border-bottom: 2px solid #f77f74 !important;
  };
.ant-menu-inline, .ant-menu-item:after {
    border-right: 3px solid #ff3f71 !important;
  }
  `};
  ${({ fontSize }) =>
    fontSize
      ? `
  .ant-menu-item div {
    font-size: ${fontSize};
  }`
      : ''}
`;

export const StyledMenuItemDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0.1;
  border-left: solid 1px #ebebeb;
  padding: 0;
  cursor: default;
`;

export const StyledSubMenu = styled(SubMenu)`
  display: flex;
  flex: 0.1;
  justify-content: center;
  align-items: center;
  border-left: solid 1px #ebebeb;
`;

export const StyledMenuTitle = styled('div')`
  width: 16.6%;
  height: 100%;
  display: flex;
  justify-content: center;
  font-family: 'Heebo-Light';
  align-items: center;
  ${({ color }) => color && `color: ${color};`}
  ${props =>
    props.hoverable
      ? `
    &:hover {
      color: ${props.hoverColor || buttonHover};
      &>div.title-link {
        border-bottom: 1px solid ${props.color || buttonHover};
      }
    }
  `
      : ''}
`;

export const StyledMenuTitleValue = styled('div')`
  font-size: ${({ theme }) => theme.fontSize.xlarger};
`;
export const UpgradePopoverText = styled('div')`
  font-size: ${({ theme }) => theme.fontSize.larger};
`;
export const MenuTitleDescContainer = styled('div')`
  margin-left: 5px;
`;
export const MenuTitleDescRow = styled('div')`
  font-size: 12px;
  line-height: 13px;
  white-space: pre-wrap;
`;

export const SettingsButtonsContainer = styled.div`
  width: 66px;
  height: 32px;
  border-radius: 16px;
  border: solid 1px ${({ theme }) => theme.colors.greyInputBorder};
  display: flex;
  justify-content: space-around;
`;

export const SanityCheckButton = props => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: center;
        &:hover {
          cursor: pointer;
        }
      `}
      onClick={props.onClick}
    >
      <div
        css={css`
          width: 40px;
          height: 40px;
          opacity: 0.7;
          border: solid 1px ${colors[props.color]};
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        `}
      >
        <div
          css={css`
            width: 32px;
            height: 32px;
            border: solid 2px ${colors[props.color]};
            border-radius: 50%;
          `}
        />
      </div>
      <IconSvg
        type="more-arrow-thin"
        width="10"
        height="5"
        css={css`
          position: absolute;
          transition: 0.2s;
          ${props.isSanityCheckOpen && 'transform: rotate(180deg); margin-left: 1px;'}
        `}
      />
    </div>
  );
};

export const Logout = props => {
  return (
    <div
      css={css`
        &:hover {
          cursor: pointer;
        }
      `}
      onClick={props.onClick}
    >
      <IconSvg
        type="logout-icon"
        color={themeColors.dirtyBlue}
        hoverColor={themeColors.blue}
        size={21}
      />
    </div>
  );
};

export const PlanUsagePopover = ({ statusMessage, closeAction, openSubscriptionSettings }) => {
  return (
    <React.Fragment>
      <UpgradePopoverText>
        <FormattedMessage id={statusMessage} />
      </UpgradePopoverText>
      <p>
        <FormattedMessage id="subscription.warning" />
      </p>
      <div
        css={css`
          display: flex;
          align-items: center;
          margin: 10px 0 5px;
        `}
      >
        <Button
          onClick={closeAction}
          size="large"
          css={css`
            margin-right: 10px;
            border-radius: 20px;
          `}
        >
          <FormattedMessage id="common.dismiss" />
        </Button>
        <Button
          type="primary"
          onClick={openSubscriptionSettings}
          size="large"
          css={css`
            border-radius: 20px;
            display: flex;
            align-items: center;
          `}
        >
          <FormattedMessage id="subscription.upgradePlan" />
          <IconSvg
            css={css`
              margin-left: 7px;
            `}
            type="space-ship"
            size={25}
          />
        </Button>
      </div>
      <IconSvg
        type="x"
        size={8}
        onClick={closeAction}
        css={css`
          position: absolute;
          top: 20px;
          right: 10px;
        `}
      />
    </React.Fragment>
  );
};
